import { render, staticRenderFns } from "./ServiceWizardLayout.vue?vue&type=template&id=4745d344&"
import script from "./ServiceWizardLayout.vue?vue&type=script&lang=js&"
export * from "./ServiceWizardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports